<template>
  <div class="autocomplete__wrapper">
    <b-input-group v-if="!loading">
    <b-form-input
      type="text"
      :class="inputClass"
      :placeholder="placeholder"
      v-model="terms"
      @focus="resetStatus"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
      @blur="$emit('blur')"
      :state="st"
    />

    <div v-if="isVisible" class="autocomplete__results">
      <ul>
        <li
          v-for="(item, index) in results"
          :key="index"
          @click="setValue(item)"
          :class="{ 'is-active': index === arrowCounter }"
          @mouseover="arrowCounter = index"
        >{{ item[text] }}</li>
      </ul>
    </div>
    <template v-slot:append>
    <b-button variant="light" :disabled="st === false" @click="resetField">
      <i class="fa fa-trash text-danger"></i>
    </b-button>
    </template>
    </b-input-group>
    <span v-else class="loading__caption">{{ loadingCaption }}</span>
  </div>
</template>

<script>
export default {
  props: {
    inputClass: {
      type: String
    },
    placeholder: {
      type: String,
      default: 'Buscar ...'
    },
    text: {
      type: String,
      default: 'text'
    },
    value: {
      type: String,
      default: 'value'
    },
    data: {
      type: Array
    },
    minLength: {
      type: Number | String,
      default: 3
    },
    loading: {
        type: Boolean,
        default: false
    },
    loadingCaption: {
        type: String,
        default: 'Cargando ...'
    },
    state: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      terms: '',
      itemSelected: false,
      arrowCounter: -1
    };
  },
  computed: {
    st() {
      if (!this.itemSelected && this.terms.length) {
        return false
      }
      return this.state || null;
    },
    isVisible() {
      return this.results.length && !this.itemSelected;
    },
    results() {
      const terms = this.terms;
      if (terms.length >= this.minLength) {
        const words = terms.split(' ');
        const all = this.data.filter(item =>
          words.every(
            w => item[this.text].toLowerCase().indexOf(w.toLowerCase()) > -1
          )
        );
        return all;
        //return all.slice(0, 5);
      }
      return [];
    }
  },
  methods: {
    resetField() {
      this.setValue(false);
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
        const item = this.results[this.arrowCounter]
        if (!item && this.terms.length) {
          return this.setValue(this.results.find(el => el.value == this.terms));
        }
        this.setValue(item);
    },
    setValue(item) {
      if (item) {
        this.terms = item[this.text] || '';
        this.itemSelected = true;
        this.arrowCounter = -1
        this.$emit('selected', item);
      } else {
        this.terms = '';
        this.$emit('selected', {
          text: '',
          value: ''
        })
      }
    },
    resetStatus(e) {
      e.target.select();
      this.itemSelected = false;
    }
  }
};
</script>

<style scoped>
.autocomplete__wrapper {
  width: 100%;
  position: relative;
}
.autocomplete__results {
  position: absolute;
  width: 100%;
  background-color: #fff;
  z-index: 9;
  border: 1px solid #eee;
}
.autocomplete__results ul {
  margin: 0;
  list-style: none;
  padding: 0;
}

.autocomplete__results ul li {
  padding: 3px 10px;
  cursor: pointer;
  font-size: 12px;
}

.autocomplete__results ul li.is-active {
  background-color: #4aaeb9;
  color: white;
}

.loading__caption {
    font-size: 12px;
}
</style>
